import React, { Component } from "react";
import { Divider, Typography, notification, Spin, Alert, Select } from "antd";
import { Input } from "antd";
import {
  ApiOutlined,
  CheckCircleOutlined,
  ShopOutlined,
} from "@ant-design/icons";
import {
  Form,
  FormItem,
  ButtonItem,
  InputItem,
  SwitchItem,
  SelectItem,
  SelectEmbudosItem,
} from "../../../../Components/Items";
import axios from "axios";
import { connect } from "react-redux";

const { Title, Text } = Typography;
const { Option } = Select;

const TOKEN_MASK = "••••••••";

class ConfiguracionShopify extends Component {
  formRef = React.createRef();

  state = {
    cargando: true,
    guardando: false,
    probando: false,
    configExistente: null,
    etapasDisponibles: [],
    ultimaSincronizacion: null,
  };

  componentDidMount() {
    this.cargarConfig();
  }

  cargarConfig = () => {
    this.setState({ cargando: true });
    axios
      .post(
        "shopify/obtenerConfigShopify",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2 && res.data.config) {
          const cfg = res.data.config;
          this.setState(
            { cargando: false, configExistente: cfg, ultimaSincronizacion: cfg.ultimaSincronizacion },
            () => {
              this.formRef.current?.setFieldsValue({
                dominio: cfg.dominio,
                apiKey: cfg.apiKey || "",
                accessToken: TOKEN_MASK,
                embudoId: cfg.embudoId,
                etapaInicialId: cfg.etapaInicialId,
                modoDistribucion: cfg.modoDistribucion || "roundRobin",
                activo: cfg.activo !== false,
              });
              if (cfg.embudoId) {
                this.cargarEtapas(cfg.embudoId, cfg.etapaInicialId);
              }
            },
          );
        } else {
          this.setState({ cargando: false });
        }
      })
      .catch(() => this.setState({ cargando: false }));
  };

  cargarEtapas = (embudoId, etapaInicialId) => {
    if (!embudoId) {
      this.setState({ etapasDisponibles: [] });
      return;
    }
    axios
      .post(
        "embudos/selectEmbudosItem",
        { query: embudoId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2 && res.data.embudos.length > 0) {
          const etapas = res.data.embudos[0].etapas || [];
          this.setState({ etapasDisponibles: etapas });
          if (etapaInicialId) {
            this.formRef.current?.setFieldsValue({ etapaInicialId });
          }
        }
      });
  };

  probarConexion = () => {
    const dominio = this.formRef.current?.getFieldValue("dominio");
    const accessToken = this.formRef.current?.getFieldValue("accessToken");
    const apiKey = this.formRef.current?.getFieldValue("apiKey");

    if (!dominio) {
      notification.warning({ message: "Ingresa el dominio antes de probar." });
      return;
    }

    this.setState({ probando: true });
    axios
      .post(
        "shopify/probarConexionShopify",
        { empresaId: this.props.empresaId, dominio, apiKey, accessToken },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          notification.success({ message: res.data.message });
        } else {
          notification.error({ message: res.data.message });
        }
      })
      .catch(() => notification.error({ message: "Error al probar la conexión." }))
      .finally(() => this.setState({ probando: false }));
  };

  guardar = (valores) => {
    this.setState({ guardando: true });
    axios
      .post(
        "shopify/guardarConfigShopify",
        { ...valores, empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          notification.success({ message: res.data.message });
          this.cargarConfig();
        } else {
          notification.error({ message: res.data.message });
        }
      })
      .catch(() => notification.error({ message: "Error al guardar la configuración." }))
      .finally(() => this.setState({ guardando: false }));
  };

  render() {
    const {
      cargando,
      guardando,
      probando,
      configExistente,
      etapasDisponibles,
      ultimaSincronizacion,
    } = this.state;

    const etapasOrdenadas = [...etapasDisponibles].sort(
      (a, b) => (a.orden ?? 0) - (b.orden ?? 0),
    );

    if (cargando) {
      return (
        <div style={{ textAlign: "center", padding: 60 }}>
          <Spin size="large" />
        </div>
      );
    }

    return (
      <div style={{ maxWidth: 620, margin: "0 auto", padding: "16px 0" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6 }}>
          <ShopOutlined style={{ fontSize: 22, color: "#95bf47" }} />
          <Title level={4} style={{ margin: 0 }}>
            Integración con Shopify
          </Title>
        </div>
        <Text type="secondary" style={{ display: "block", marginBottom: 20 }}>
          Los clientes nuevos en Shopify se importan automáticamente cada hora como leads.
          Prioridad de asignación: usuarios con WhatsApp (celular) configurado van primero.
        </Text>

        {ultimaSincronizacion ? (
          <Alert
            type="success"
            icon={<CheckCircleOutlined />}
            showIcon
            style={{ marginBottom: 20 }}
            message={
              <Text>
                Última sincronización:{" "}
                <strong>
                  {new Date(ultimaSincronizacion).toLocaleString("es-MX", {
                    dateStyle: "medium",
                    timeStyle: "short",
                  })}
                </strong>
              </Text>
            }
          />
        ) : (
          <Alert
            type="info"
            style={{ marginBottom: 20 }}
            message='Sin sincronizaciones previas. Usa el botón "Shopify" en el tablero CRM para sincronizar.'
          />
        )}

        <Form
          ref={this.formRef}
          layoutForm="vertical"
          onFinish={this.guardar}
          initialValues={{ modoDistribucion: "roundRobin", activo: true }}
          onValuesChange={(changed) => {
            if ("embudoId" in changed) {
              const savedId = this.state.configExistente?.embudoId?.toString();
              const newId = changed.embudoId?.toString();
              if (savedId && newId && newId === savedId) return;
              this.formRef.current?.setFieldsValue({ etapaInicialId: undefined });
              this.cargarEtapas(changed.embudoId);
            }
          }}
        >
          <Divider orientation="left" orientationMargin={0}>
            Credenciales
          </Divider>

          <FormItem
            label="Dominio de la tienda"
            name="dominio"
            required
            extra="Ejemplo: mi-tienda.myshopify.com"
          >
            <InputItem placeholder="mi-tienda.myshopify.com" />
          </FormItem>

          <FormItem
            label="API Key"
            name="apiKey"
            extra={
              configExistente?.apiKey
                ? "Haz clic para cambiar. Deja vacío para conservar el guardado."
                : "Panel Shopify → Configuración → Apps → Desarrollar apps. Opcional si usas Custom App con solo Access Token."
            }
          >
            <Input.Password
              placeholder={configExistente?.apiKey ? "Haz clic para cambiar" : "Pegar API Key aquí"}
              onFocus={() => {
                if (this.formRef.current?.getFieldValue("apiKey") === TOKEN_MASK) {
                  this.formRef.current.setFieldsValue({ apiKey: "" });
                }
              }}
            />
          </FormItem>

          <FormItem
            label="Access Token"
            name="accessToken"
            required={!configExistente}
            extra={
              configExistente
                ? "Haz clic para cambiar. Deja vacío para conservar el guardado."
                : "Token de acceso de tu app privada o custom app de Shopify."
            }
          >
            <Input.Password
              placeholder={configExistente ? "Haz clic para cambiar" : "shpat_xxxxxxxxxxxxxxxx"}
              onFocus={() => {
                if (this.formRef.current?.getFieldValue("accessToken") === TOKEN_MASK) {
                  this.formRef.current.setFieldsValue({ accessToken: "" });
                }
              }}
            />
          </FormItem>

          <FormItem>
            <ButtonItem blanco icon={<ApiOutlined />} onClick={this.probarConexion} loading={probando}>
              Probar conexión
            </ButtonItem>
          </FormItem>

          <Divider orientation="left" orientationMargin={0}>
            Destino de los leads
          </Divider>

          <FormItem label="Embudo destino" name="embudoId" required>
            <SelectEmbudosItem
              headersToken={this.props.headersToken}
              placeholder="Selecciona un embudo"
              style={{ width: "100%" }}
              empresaId={this.props.empresaId}
            />
          </FormItem>

          <FormItem
            label="Etapa inicial"
            name="etapaInicialId"
            required
            extra="Los clientes de Shopify entrarán en esta etapa."
          >
            <SelectItem
              placeholder="Selecciona una etapa"
              disabled={etapasOrdenadas.length === 0}
              style={{ border: "1px solid #d9d9d9", borderRadius: 4 }}
            >
              {etapasOrdenadas.map((e) => (
                <Option key={e._id} value={e._id}>
                  <span
                    style={{
                      display: "inline-block",
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                      backgroundColor: e.color,
                      marginRight: 8,
                    }}
                  />
                  {e.nombre}
                </Option>
              ))}
            </SelectItem>
          </FormItem>

          <Divider orientation="left" orientationMargin={0}>
            Distribución de leads
          </Divider>

          <FormItem
            label="Modo de asignación"
            name="modoDistribucion"
            extra="Los usuarios con WhatsApp (celular) registrado tienen prioridad automática en los modos automáticos."
          >
            <SelectItem noBuscar style={{ border: "1px solid #d9d9d9", borderRadius: 4 }}>
              <Option value="roundRobin">Round Robin — uno por uno en orden</Option>
              <Option value="autoAsignar">Auto Asignar — al que tenga menos leads activos</Option>
              <Option value="gestionar">Gestionar manualmente — tú asignas cada lead</Option>
            </SelectItem>
          </FormItem>

          <FormItem label="Integración activa" name="activo" valuePropName="checked">
            <SwitchItem checkedChildren="Activa" unCheckedChildren="Pausada" />
          </FormItem>

          <Divider />

          <div style={{ display: "flex", gap: 10 }}>
            <ButtonItem azul htmlType="submit" loading={guardando}>
              Guardar configuración
            </ButtonItem>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ConfiguracionShopify);
